<template>
  <div
    :class="[
      ns.b('dragger'),
      ns.is('dragover', dragover),
      ns.is('disabled', disabled),
    ]"
    data-component-name="Upload"
    data-event-name="drop"
    data-event-content="文件被拖入上传区域"
    @drop.prevent="onDrop"
    @dragover.prevent="onDragover"
    @dragleave.prevent="dragover = false"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { inject, ref } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { useFormDisabled } from '@jdesign-vue/components/form'
import { throwError } from '@jdesign-vue/utils/error'
import { uploadContextKey } from './constants'
import { uploadDraggerEmits, uploadDraggerProps } from './upload-dragger'
import { checkAccept, traverseFileTree } from './utils'

const COMPONENT_NAME = 'JdUploadDrag'

defineOptions({
  name: COMPONENT_NAME,
})

const props = defineProps(uploadDraggerProps)
const emit = defineEmits(uploadDraggerEmits)

const uploaderContext = inject(uploadContextKey)
if (!uploaderContext) {
  throwError(
    COMPONENT_NAME,
    'usage: <jd-upload><jd-upload-dragger /></jd-upload>'
  )
}

const ns = useNamespace('upload')
const dragover = ref(false)
const disabled = useFormDisabled()

const onDrop = async (e: DragEvent) => {
  if (props.disabled) return
  dragover.value = false

  const accept = uploaderContext.accept.value
  let files: File[] = []

  if (uploaderContext.directory.value) {
    await traverseFileTree(
      Array.prototype.slice.call(e.dataTransfer!.items),
      (_files: File[]) => (files = files.concat([..._files]))
    )
  } else {
    files = Array.from(e.dataTransfer!.files)
  }
  if (!accept) {
    emit('file', files)
    return
  }

  const filesFiltered = files.filter((file) => checkAccept(file, accept))

  emit('file', filesFiltered)
}

const onDragover = () => {
  if (!disabled.value) dragover.value = true
}
</script>
